import { styled } from '@mui/material'

export const TextIconButton = styled('button')`
  text-decoration: none;
  color: ${({ theme, color }) => color ?? theme.colors.shade0};
  display: inline-flex;
  gap: 8px;
  word-break: break-all;
  p {
    text-underline-offset: 2px;
    text-decoration-thickness: 1px;
  }
  .material-symbols-outlined {
    color: ${({ theme, color }) => color ?? theme.colors.secondary100};
  }
  cursor: pointer;
  border: none;
  background-color: transparent;
`
